import { api } from '@/lib/trpc/react';

type UseUpdateUser = {
  onSuccess?: ({
    workspaceName,
    displayName,
  }: {
    workspaceName?: string;
    displayName?: string;
  }) => void;
  onError?: () => void;
};

const useUpdateUser = ({ onSuccess, onError }: UseUpdateUser = {}) => {
  const utils = api.useUtils();
  const { mutateAsync: updateUser } = api.user.update.useMutation({
    onMutate: async ({ email, ...rest }) => {
      await utils.user.byEmail.cancel();

      const prevData = utils.user.byEmail.getData(email);

      utils.user.byEmail.setData(email, (prev) =>
        prev ? { ...prev, ...rest } : undefined,
      );

      return { prevData };
    },
    onError(_err, { email }, ctx) {
      onError?.();
      utils.user.byEmail.setData(email, ctx?.prevData);
    },
    onSettled(_, __, { email }) {
      // Sync with server once mutation has settled
      utils.user.byEmail.invalidate(email);
    },
    onSuccess: (_, params) => {
      onSuccess?.({
        ...(params.workspaceName && { workspaceName: params.workspaceName }),
        ...(params.displayName && { displayName: params.displayName }),
      });
    },
  });
  return { updateUser };
};

export default useUpdateUser;
